module.exports = __webpack_public_path__ + "static/dotpedia-globe-cdd84906a25f6c1b31f7f742e96dd0bc.png";